import { nameFormat } from '@nike/i18n-core';
import templateString from '../templateString';
import useBodega from './bodegaHook';
import useLocale from './localeHook';
import useFeatureFlags from './featureFlagsHook';
import { GLOBAL_NAV_KOREAN_FULL_NAME } from '../../constants';
import useIdentity from './identityHook';

/**
 * hook to get user greeting
 * surprising number of hooks required to get this snippet of data
 * @returns {string} formatted name of user
 */
const useGetUserGreeting = () => {
  const { userProfile } = useIdentity();
  const locale = useLocale();
  const isKoreanFullName = useFeatureFlags(GLOBAL_NAV_KOREAN_FULL_NAME);
  const { firstName, lastName } = userProfile || {};

  const nameToDisplay = nameFormat({
    givenName: firstName,
    familyName: lastName,
    locale: locale?.intl || 'en-US',
    style: isKoreanFullName ? 'medium' : 'short',
  }).trim();

  // Display fallback account label if we don't have useable name data
  if (!nameToDisplay) {
    return useBodega('nav_fallback_account');
  }
  return templateString(useBodega('nav_title_greeting_membership', 'Hi, {name}'), {
    name: nameToDisplay,
  });
};

export default useGetUserGreeting;
